export enum SIC_System {
EFKA,
OAED,
EFORIA,
OSYK,
}
